(function () {
	'use strict';

	angular
		.module('FormBuilder')
		.directive('fbFieldDaterangepicker', fbFieldDaterangepickerDirective);

	function fbFieldDaterangepickerDirective($timeout) {
		return {
			restrict: 'EA',
			scope: {
				element:'=',
				model: '='
			},
			templateUrl: 'common/libraries/formBuilder/fields/fieldDaterangepicker',
			controller: fbFieldDaterangepickerDirectiveCtrl,
			controllerAs: 'vm',
			bindToController: true,
			link: function(scope) {
			}
		};
	}

	function fbFieldDaterangepickerDirectiveCtrl(lodash, FormBuilderService, $scope) {
		var vm = this;
		this.$onInit = function() {
			var formIdentifier = $scope.$parent.vm.formIdentifier;

			FormBuilderService.sync(formIdentifier, vm);

			vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
			vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
			vm.options = angular.merge({},
				lodash.get(vm.element,'attr.options',{})
			);
		}
	}
})();